import { initials } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import { queryClient } from 'App';
import Avatar from 'components/common/Avatar';
import { useAuth } from 'context/AuthProvider';
import { useUser } from 'context/UserContext';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const ProfileDropdown = () => {
  const user = useUser();
  const userProfilePic = createAvatar(initials, {
    seed: user?.username,
    size: 100,
    backgroundColor: ['1e88e5']
  }).toDataUriSync();

  const { signOut } = useAuth();

  const handleLogout = async e => {
    e.preventDefault();
    queryClient.invalidateQueries({ queryKey: ['userData'] });
    const { error } = await signOut();
    if (error) {
      toast.error('Errore durante il logout');
      return;
    }
    toast.success('Hai effettuato il logout con successo');
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={userProfilePic} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to="/account">
            Impostazioni
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            className="text-danger"
            as={Link}
            onClick={handleLogout}
          >
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
